class TabHandler {
    constructor (tabNav, tabContent, leftBtn, rightBtn) {
        this.tabNav = tabNav;
        this.tabContent = tabContent;
        this.leftBtn = leftBtn;
        this.rightBtn = rightBtn;
        this.currentActiveTabIndex = '';
        this.currentActiveTabContentIndex = '';
        this.goNext = this.goNext.bind(this);
        this.goPrevious = this.goPrevious.bind(this);
    }

    findActive (toFind) {
        const activeElement = toFind.findIndex(el => el.classList.contains('active'));
        return activeElement;
    }

    init () {
        this.leftBtn.forEach(el => el.addEventListener('click', this.goPrevious));
        this.rightBtn.forEach(el => el.addEventListener('click', this.goNext));
    }
    //TODO : te dwie funkcje najlepiej napisać ponownie (goPrevious, goNext) 
    goPrevious () {
        this.currentActiveElements();
        this.tabNav[this.currentActiveTabIndex].classList.remove('active');
        this.tabContent[this.currentActiveTabContentIndex].classList.remove('show');
        setTimeout(() => {
            this.tabContent[this.currentActiveTabContentIndex].classList.remove('active')

            if(this.currentActiveTabIndex != 0) {
                this.tabNav[this.currentActiveTabIndex - 1].classList.add('active');
                this.tabContent[this.currentActiveTabContentIndex - 1].classList.add('active');
                setTimeout(() => {
                    this.tabContent[this.currentActiveTabContentIndex - 1].classList.add('show');
                }, 150)
                return;
            }
            this.tabNav[2].classList.add('active');
            this.tabContent[2].classList.add('active');
            setTimeout(() => {
                this.tabContent[2].classList.add('show');
            }, 150)

        },150)
    }
    goNext () {
        this.currentActiveElements();

        this.tabNav[this.currentActiveTabIndex].classList.remove('active');
        this.tabContent[this.currentActiveTabContentIndex].classList.remove('show');
        setTimeout(()=> {
            this.tabContent[this.currentActiveTabContentIndex].classList.remove('active')

            if(this.currentActiveTabIndex != 2) {
                this.tabNav[this.currentActiveTabIndex + 1].classList.add('active');
                this.tabContent[this.currentActiveTabContentIndex + 1].classList.add('active');
                setTimeout(() => {
                    this.tabContent[this.currentActiveTabContentIndex + 1].classList.add('show');
                }, 150)

                return;
            }
            this.tabNav[0].classList.add('active');
            this.tabContent[0].classList.add('active');
            setTimeout(() => {
                this.tabContent[0].classList.add('show');
            }, 150)

        },150)


    }
    currentActiveElements () {
        this.currentActiveTabIndex = this.findActive(this.tabNav);
        this.currentActiveTabContentIndex = this.findActive(this.tabContent);
    }
}

export default TabHandler;


// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/modules/tabHandler.js